export const SINGLE_ACTIVE_LOGIN_ENABLED =
	String(
		process.env.REACT_APP_SINGLE_ACTIVE_LOGIN_ENABLED ?? 'true'
	).toLowerCase() === 'true';

// true (default): register coba SMS OTP dulu, dengan fallback Email OTP jika SMS gagal
// false: lewati SMS dan langsung gunakan Email OTP
export const SMS_OTP_ENABLED =
	String(process.env.REACT_APP_SMS_OTP_ENABLED ?? 'true').toLowerCase() ===
	'true';

// true (default): fitur Live Class aktif penuh.
// false: tampilkan halaman "Segera Hadir" — dipakai saat awal rilis sebelum
// instruktur siap. Menu tetap terlihat agar user tahu fitur ini akan datang.
export const LIVE_CLASS_ENABLED =
	String(process.env.REACT_APP_LIVE_CLASS_ENABLED ?? 'true').toLowerCase() ===
	'true';
